<template>
  <ul class="setting-warp" v-show="visible">
    <li class="setting-warp-item">
      <span class="setting-warp-item_label">{{$t('retrieval.bankType')}}</span>
      <el-select clearable class="bank-type" size="small" v-model="filter.corpusType"
                 :placeholder="$t('jobManagementV2.selectText')">
        <el-option v-for="item in selectOptions.corpusTypeOptions" :key="item.value"
                   :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </li>
    <li class="setting-warp-item lang-item">
      <span class="setting-warp-item_label">{{$t('memoryBankV2.languageDirectionNoColon')}}</span>
      <el-select clearable size="small" v-model="filter.sourceLang"
                 :placeholder="$t('jobManagementV2.selectText')" @change="handlechangeSourceLang">
        <el-option v-for="(item,index) in selectOptions.sourceLangOptions" :key="index"
                   :label="$i18n.locale==='zh'?item.sourceLangName:getEnlang(item.sourceLang)"
                   :value="item.sourceLang">
        </el-option>
      </el-select>
      <i class="language-btn"></i>
      <el-select class="language-target" :no-data-text="$t('newProjectV2.firstSelSourceLangTip')"
                 clearable size="small" v-model="filter.targetLang"
                 :placeholder="$t('jobManagementV2.selectText')">
        <el-option v-for="(item,index) in selectOptions.targetLangOptions" :key="index"
                   :label="$i18n.locale==='zh'?item.targetLangName:getEnlang(item.targetLang)"
                   :value="item.targetLang">
        </el-option>
      </el-select>
    </li>
    <li class="setting-warp-item">
      <span class="setting-warp-item_label">{{$t('memoryBankV2.domainNoColon')}}</span>
      <el-select clearable class="bank-type" size="small" v-model="filter.domainCode"
                 :placeholder="$t('jobManagementV2.selectText')">
        <el-option v-for="item in selectOptions.domainOptions" :key="item.dataKey"
                   :label="$i18n.locale==='zh'?item.dataDesc:getEnDomain(item.dataKey)"
                   :value="item.dataKey">
        </el-option>
      </el-select>
    </li>
  </ul>
</template>

<script>
import { getLang, getOptionList } from '@/services/memoryBank';
export default {
  name: 'RetrievalSetting',
  props: {
    value: {
      type: Object,
      default: () => { }
    },
    visible: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      selectOptions: {
        corpusTypeOptions: [
          { label: this.$t('common.all'), value: 0 },
          { label: this.$t('newProjectV2.memoryBank'), value: 1 },
          { label: this.$t('newProjectV2.termBank'), value: 2 }
        ],
        sourceLangOptions: [],
        targetLangOptions: [],
        domainOptions: []
      }
    }
  },
  computed: {
    filter: {
      get () {
        return this.value
      },
      set (val) {
        console.log(val);
        this.$emit('input', val)
      }
    },
  },

  mounted () {
    this.$nextTick(() => {
      this.getLangList({ type: 1 })
      this.getDomainList()
    })
  },
  methods: {
    // 获取源语言
    async getLangList (params) {
      const { type } = params
      const { success, result } = await getLang(params)
      if (!success) return
      if (type === 1) {
        this.selectOptions.sourceLangOptions = result
      } else {
        this.selectOptions.targetLangOptions = result.filter(item => item.status !== 0)
      }
    },
    handlechangeSourceLang (value) {
      this.filter.targetLang = ''
      if (!value) {
        this.selectOptions.targetLangOptions = []
      } else {
        this.getLangList({ type: 2, sourceLang: value })
      }
    },
    // 获取领域
    async getDomainList () {
      const params = {
        dataType: 'trans_domain'
      }
      const { success, result } = await getOptionList(params)
      if (!success) return
      this.selectOptions.domainOptions = result
    }
  }
}
</script>

<style lang="less" scoped>
.setting-warp {
  margin-top: 1.43em;
  display: flex;
  align-items: center;
  .setting-warp-item + .setting-warp-item {
    margin-left: 2.15em;
  }
  /deep/ &-item {
    display: flex;
    align-items: center;
    .el-select {
      .el-input__inner {
        width: 10.8em;
      }
    }
    &_label {
      margin-right: 0.7em;
      color: #666666;
    }
    .language-btn {
      margin: 0 1.43em;
      display: inline-block;
      width: 14px;
      height: 14px;
      background-repeat: no-repeat;
      background: url("../images/icon-lang-btn.png");
      // cursor: pointer;
      // &:hover {
      //   background: url("../images/icon-lang-btn_pre.png");
      // }
    }
  }
}
</style>